import React, { useState } from 'react';
import styles from './bildergalerie.module.css';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ImageModal from '../ImageModal/ImageModal';
function Bildergalerie({ images }) {
    const [modalImage, setModalImage] = useState(null);

    return (
        <div className={styles.galleryWrapper}>
            <ImageModal src={modalImage} onClose={() => setModalImage(null)} />
            <Carousel
                showArrows
                autoPlay
                infiniteLoop
                stopOnHover
                swipeable
                showIndicators
                showStatus={false}
                showThumbs={false}
                interval={4000}
                className={styles.carousel}
                renderItem={(item, props) => <div {...props}>{item}</div>} // Add this line
            >
                {images.map((img, idx) => (
                    <div key={idx} className={styles.imgSingleContainer}
                        onClick={() => {
                            setModalImage(img.path);
                        }}
                    >
                        <img
                            src={img.path}
                            alt={img.alt}
                            className={styles.imgSingle}
                        />
                        <div className={styles.textContainer}>
                            {img.title && <p className={styles.title}>{img.title}</p>}
                            {img.text && <p className={styles.text}>{img.text}</p>}
                            {img.subtext && <p className={styles.subtext}>{img.subtext}</p>}
                        </div>
                    </div>
                ))}
            </Carousel>
        </div>
    );
}

export default Bildergalerie;
